<script setup lang="ts">
interface Props {
  active: boolean
}

interface Emits {
  (e: 'click'): void
}

defineProps<Props>()
defineEmits<Emits>()
</script>

<template>
  <div 
    class="backdrop" 
    :class="{ active }" 
    @click="$emit('click')" 
  />
</template>

<style lang="scss" scoped>
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 90;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  
  &.active {
    opacity: 1;
    visibility: visible;
  }
  
  // Hide backdrop on mobile devices
  @media (max-width: 991px) {
    display: none;
  }
}
</style> 